import React, { useState, useEffect } from "react";
import axios from "axios";
import { Container, Row, Col } from "shards-react";
import Button from "@material-ui/core/Button";
import api from "../../common/api";
import MediaFile from "../../common/MediaFile";
import LinearProgress from "@material-ui/core/LinearProgress";
import PageTitle from "../../common/PageTitle";

const ServiceChargeImport = ({ match }) => {
  const [files, setFiles] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [loading, setLoading] = useState(false);
  const [excelLoaded, setExcelLoaded] = useState(false);
  const [errors, setErrors] = useState(null);
  const [message, setMessage] = useState(null);

  const handleUploadFile = (file, meta_data) => {
    setFiles(prev => [...prev, { file, meta_data }]);
  };

  const handleDownloadTemplate = () => {
    window.location.href = api.service_charge_import_template;
  };

  const handleSubmit = async e => {
    e.preventDefault();
    const formData = new FormData();
    files.forEach(val => {
      if (val.file && val.file.length > 0) {
        formData.set("import", val.file[0]);
      }
    });

    try {
      setLoading(true);
      const token = localStorage.getItem("userToken");
      const res = await axios.post(
        api.service().importServiceCharge(),
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`
          }
        }
      );
      setExcelLoaded(true);
      setMessage(res.data.message);
      setErrors(null);
    } catch (err) {
      const respErrors = err.response ? err.response.data : {};
      setErrors(respErrors);
      setFiles([]);
      setExcelLoaded(true);
    } finally {
      setLoading(false);
    }
  };

  const errorMessages = [];
  if (errors && errors.message) {
    const messages = Object.values(errors.message);
    messages.forEach(val => {
      const rows = Object.keys(val);
      rows.forEach(row => {
        const fields = Object.values(val[row]);
        fields.forEach(field => {
          errorMessages.push(`La línea ${row}: ${field[0]}`);
        });
      });
    });
  }

  return (
    <Container fluid className="main-content-container px-4 pb-4">
      <Row noGutters className="page-header pt-4">
        <PageTitle
          lg="12"
          title={"Actualización masiva de cargos"}
          className="text-lg-left"
        />
      </Row>
      <Row>
        <Col md="12">
          <div className="mt-2">
            {loading ? (
              <LinearProgress />
            ) : excelLoaded ? (
              errors ? (
                errorMessages.map((val, idx) => (
                  <div key={idx} className="mt-1" style={{ color: "red" }}>
                    {val}
                  </div>
                ))
              ) : (
                <div>{message}</div>
              )
            ) : (
              <React.Fragment>
                <MediaFile
                  onChange={handleUploadFile}
                  title="Agregar excel"
                  width={"15rem"}
                  height={"2rem"}
                  meta_data="comprobante"
                />
                <Button
                  className="mt-2 mr-2"
                  variant="contained"
                  color="primary"
                  size="small"
                  style={{ fontSize: "0.75rem" }}
                  onClick={handleSubmit}
                >
                  Cargar
                </Button>
              </React.Fragment>
            )}
            <Button
              className="mt-2 mr-2"
              variant="contained"
              color="primary"
              size="small"
              style={{ fontSize: "0.75rem" }}
              onClick={handleDownloadTemplate}
            >
              Descargar Template
            </Button>
            <Button
              className="mt-2"
              variant="contained"
              color="secondary"
              size="small"
              style={{ fontSize: "0.75rem" }}
              onClick={() =>
                (window.location.href =
                  "/bookings")
              }
            >
              Volver
            </Button>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default ServiceChargeImport;
